import { atom } from 'recoil'

export const pageState = atom({
  key: 'CampaignListPageState',
  default: {
    loaded: false,
    loading: false,
    fetching: false,
    fetchingLoaded: false,
    error: false,
    severity: 'danger',
    isEmptyState: false,
    updateStatusInProgress: false,
    updateStatusIdCampaign: 0
  }
})

export const resultsState = atom({
  key: 'CampaignListResultsState',
  default: {
    loadingTable: false,
    items: [],
    totalItems: 0
  }
})

export const searchState = atom({
  key: 'CampaignListSearchState',
  default: {
    pageNumber: 1,
    pageSize: 10,
    status: null,
    orderBy: 'UpdateDate',
    orderDescending: true,
    campaignName: ''
  }
})

export const configState = atom({
  key: 'CampaignListConfigState',
  default: {
    userChannels: undefined,
    mapiChannels: undefined,
    channels: undefined,
    mapiPlatforms: undefined
  }
})
